import React from "react";
import {
  StyledCard,
  StyledCardActions,
  StyledCardContent,
} from "./BaseCard.styles";

interface BaseCardProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
  isSelected?: boolean;
  isHighlighted?: boolean;
  isPreferred?: boolean;
  compact?: boolean;
  showBorder?: boolean;
  onClick?: () => void;
}

const BaseCard: React.FC<BaseCardProps> = ({
  children,
  actions,
  isSelected = false,
  isHighlighted = false,
  isPreferred = false,
  compact = false,
  showBorder = true,
  onClick,
}) => (
  <StyledCard
    isSelected={isSelected}
    isHighlighted={isHighlighted}
    isPreferred={isPreferred}
    compact={compact}
    showBorder={showBorder}
    clickable={Boolean(onClick)}
    onClick={onClick}
  >
    <StyledCardContent compact={compact}>{children}</StyledCardContent>
    {actions && (
      <StyledCardActions compact={compact} disableSpacing>
        {actions}
      </StyledCardActions>
    )}
  </StyledCard>
);

export default BaseCard;
